export const removeUnitedStatesFromAddress = (address: string) => {
  return address.replace(/, United States$/, '');
};
